<template lang="html">


  <div class="wrapper margin-menu">

    <section class="intro column-center -fundacion">
      <h2>La Fundación</h2>
      <h1>Plan de actuación</h1>
    </section>

    <section class="breadcrumb">
      <nav class="container row-end">
        <router-link to="/">Inicio</router-link>
        <router-link :to="$t('enlaces.lafundacion')">La Fundación</router-link>
        <router-link :to="$t('enlaces.planesactuacion')">Plan de actuación</router-link>
      </nav>
    </section>

    <main>

      <div class="container">

        <h2 class="title-intro">
          Nuestros proyectos, con <strong>transparencia</strong>
        </h2>

        <p class="texto-intro">
          A través de nuestra web facilitamos toda la información relevante de los proyectos que realizamos. Es nuestro compromiso de transparencia.
        </p>

      </div>


      <div class="white-box">
        <div class="container row-start">
          <h2 class="big-title">Actuación</h2>
        </div>
        <div class="red-border-box">
          <h2 class="title-intro">
            Planes de <strong>actuación</strong>
          </h2>
          <p><strong>Según lo establecido por la ley, el Patronato de la Fundación Tomás Pascual y Pilar Gómez-Cuétara
              elabora un plan de actuación que refleja los objetivos y actuaciones a
              desarrollar en el siguiente ejercicio</strong>, ajustado al modelo aprobado por el Real decreto
            (1611/2007). Este documento permite fijar la estrategia de funcionamiento y actividad, con
            un desglose detallado tanto de la actividad como de los gastos y recursos previstos para su aplicación. Se
            remite al Protectorado del Ministerio de Educación, Cultura y deporte de
            Fundaciones durante los últimos 3 meses de cada ejercicio. </p>
          <a class="btn with-border" target="_blank" href="/static/pdf/plan-actuacion.pdf">Descargar planes</a>
          <img src="/static/img/imagen-actuacion.svg" class="imagen-actuacion">
        </div>
        <div class="title-container row-end">
          <h3 class="title-destacado">En cada plan de actuación indicamos los objetivos, actividades, beneficiarios y gastos asociados al plan.</h3>
        </div>
      </div>



      <!-- <div class="grey-box column-center -metodologia">
        <div class="container">
          <h2>METODOLOGÍA DE EVALUACIÓN DE LA
            CALIDAD DE PROGRAMAS EN CENTRO DE
            INVESTIGACIÓN EN VALORES (CIVSEM):</h2>
          <p>Los Programas que, actualmente se llevan a cabo en CIVSEM pueden encuadrarse en trea áreas:</p>
          <ul>
            <li>• Programas Sociales DPOP (500)*, DPOP Adolescentes (105), De-POP online (75)</li>
            <li>• Programas Profesionales Coaching Social (42), Emprendedores (8)</li>
            <li>• Programas para Empresas: Vivir los Valores en la Empresa<span>*El número entre paréntesis indica el
                número de asistentes en la última edición de cada programa.</span></li>
          </ul>
        </div>
      </div> -->



      <div class="cuerpos-metodos container row-between">

        <h4 class="destacado">Métodos para seguir la calidad y efectividad de nuestros programas</h4>

        <div class="cuerpo-metodo">
          <h2>Asistentes por programa</h2>
          <p>Sabemos que la mayor parte de nuestros alumnos vienen por las referencias de otros que se han formado
            anteriormente, por eso el número de alumnos por programa es uan referencia de calidad
            y satisfacción de alumnos de programas anteriores.</p>
        </div>

        <div class="cuerpo-metodo">
          <h2>Referencia de los alumnos</h2>
          <p>Otra medida utilizada para medir la calidad de los Programas es el tanto por ciento de alumnos que pasan de
            unos cursos a otros y que finalmente forman parte de las asociaciones creadas
            para antiguos alumnos o profesionales.</p>
        </div>

        <div class="cuerpo-metodo">
          <h2>Entrevistas de seguimiento</h2>
          <p>Todos los programas son seguidos a medio plazo, después de su finalización, para conocer el impacto
            generado, los resultados obtenidos y la visión de los alumnos después de haberlos
            acabado. Se hacen entrevistas a una muestra de alumnos a los 6 meses de la finalización y al cabo de dos
            años.</p>
        </div>

        <div class="cuerpo-metodo full">
          <h2>Seguimiento y evaluación</h2>
          <p>Todos los programas de larga duración disponen de sesiones intermedias de Comunidad de Aprendizaje, con
            personas ajenas a los formadores y a la Organización, con el fin de que los alumnos
            puedan manifestar su grado de satisfacción y cumplimiento de expectativas, pero con la posibilidad de tomar
            medidas antes del final del Curso. Tanto estos programas como los mas cortos se
            evalúan con encuestas finales de satisfacción de los asistentes.</p>
        </div>

      </div>


    </main>

  </div>

</template>

<script lang="js">


  export default {
    name: 'planes-de-actuacion',
  }

</script>


<style lang="scss">

@media screen and (max-width: 950px){
  .red-border-box{
    max-width: calc(100% - 40px);
    margin-top: 20px;

    p{
      font-size:16px;
    }
  }
}

</style>


// WEBPACK FOOTER //
// src/components/views/planes-de-actuacion.vue